import { Component, OnInit, Input, SimpleChanges, OnChanges, ViewChild } from '@angular/core'
import { Facility } from '../types/Facility'
import { FacilityService } from '../services/facility.service';
import { ProspectListItem } from '../types/ProspectListItem';
import { BusinessModel } from '../types/BusinessModel';
import { Utility } from '../../common/service/utility';
import { BidCompany } from '../types/BidCompany';
import { ADUser } from '../../common/model/ADUser'
import { DxDropDownBoxComponent } from 'devextreme-angular';

@Component({
  selector: 'business-potential',
  templateUrl: './business-potential.component.html',
  styleUrls: ['./business-potential.component.scss'],
})
export class BusinessPotentialComponent implements OnInit, OnChanges {
  @ViewChild("BidCompaniesSelectBox", { static: false }) bidCompaniesSelectBox: DxDropDownBoxComponent;
  @Input() isNewFacility: Boolean;
  @Input() facility: Facility;
  @Input() businessModels: BusinessModel[];
  @Input()
  get facilityType(): string { return this._facilityType; }
  set facilityType(facilityType: string) {
    if (facilityType === 'General') {
      this.isGeneralFacilityType = true;
      this.isHYCOFacilityType = false;
      this.isLASUFacilityType = false;
    } else if (facilityType === 'HYCO') {
      this.isHYCOFacilityType = true;
      this.isGeneralFacilityType = false;
      this.isLASUFacilityType = false;
    } else if (facilityType === "LASU") {
      this.isLASUFacilityType = true;
      this.isGeneralFacilityType = false;
      this.isHYCOFacilityType = false;
    }
  }
  _facilityType: string;
  companyName: string;
  isGeneralFacilityType: boolean = true;
  isHYCOFacilityType: boolean = false;
  isLASUFacilityType: boolean = false;
  businessModelVisible: boolean = false;
  bidCompanySearchVisible: boolean = false;
  selectedRowKeys: number[] = [];
  supplyModes: ProspectListItem[];
  supplyTypes: ProspectListItem[];
  gridBoxValue: number[] = [];
  opportunityLead: ADUser = {
    mail: '',
    displayName: ''
  };
  lastContactedBy: ADUser = {
    mail: '',
    displayName: ''
  };
  searchModeOption = 'contains';
  minSearchLengthOption = 2;
  isLoadPanelVisible = false;
  opportunityLeadVisible = false;
  lastContactedByVisible = false;
  lastContactedByTooltipVisible = false;
  opportunityLeadTooltipVisible = false;


  constructor(private facilityService: FacilityService, private utility: Utility) {
    this.validateSupplyMode = this.validateSupplyMode.bind(this);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.facility.businessPotential !== undefined && this.facility.businessPotential !== null && this.facility.businessPotential) {
      if (this.facility.businessPotential.bidCompanies !== undefined && this.facility.businessPotential.bidCompanies !== null && this.facility.businessPotential.bidCompanies.length > 0 ) {
        this.facility.businessPotential.bidCompanies.forEach((item) => {
          if (!this.selectedRowKeys.includes(item.companyId)) {
            this.selectedRowKeys.push(item.companyId);
          }
        });
      }
    }
  }

  ngOnInit(): void {
    this.facilityService.GetSupplyTypes()
      .subscribe(
        (data: ProspectListItem[]) => {
          this.supplyTypes = data
        }
      );
    this.facilityService.GetSupplyModes()
      .subscribe(
        (data: ProspectListItem[]) => {
          this.supplyModes = data
        }
      );
  }

  validateSupplyMode(e) {
    if ((this.facility.businessPotential.estimatedBusinessModel !== undefined && this.facility.businessPotential.estimatedBusinessModel !== null && this.facility.businessPotential.estimatedBusinessModel === 'SOG') && (e.value === undefined || e.value === null)) {
      return false;
    }
    else {
      return true;
    }
  }

  onDateBoxContentReady(e) {
    e.component.option('inputAttr', { readonly: true })
  }

  displayValueFormatter(value) {
    return Array.isArray(value) ? value.join(": ") : value;
  }

  searchCompanies() {
    this.bidCompanySearchVisible = true;
  }

  closeEventSearchCompaniesPopup(closeFlag: boolean) {
    this.bidCompanySearchVisible = closeFlag;
  }

  saveEventSearchCompaniesPopup(bidCompanies: BidCompany[]) {
    bidCompanies.forEach((item) => {
      if (!this.selectedRowKeys.includes(item.companyId)) {
        this.selectedRowKeys.push(item.companyId);
        this.facility.businessPotential.bidCompanies.push(item);
      }
    })

    this.selectedRowKeys.forEach((item) => {
      if (!bidCompanies.find(i => i.companyId === item)) {
        const index = this.selectedRowKeys.indexOf(item);
        if (index > -1) {
          this.selectedRowKeys.splice(index, 1);

        }

        const indexOfObject = this.facility.businessPotential.bidCompanies.findIndex(object => {
          return object.companyId === item;
        });

        if (indexOfObject > -1) {
          this.facility.businessPotential.bidCompanies.splice(indexOfObject, 1);
        }

      }
    })

    this.bidCompaniesSelectBox.instance.repaint();
    this.bidCompanySearchVisible = false;
  }

  searchOpportunityLead() {
    this.opportunityLeadVisible = !this.opportunityLeadVisible;
  }

  searchLastContactedBy() {
    this.lastContactedByVisible = !this.lastContactedByVisible;
  }

  toggleTooltipLastContactedBy() {
    this.lastContactedByTooltipVisible = !this.lastContactedByTooltipVisible;
  }

  toggleBusinessModel() {
    this.businessModelVisible = !this.businessModelVisible;
  }

  toggleOpportunityLead() {
    this.opportunityLeadTooltipVisible = !this.opportunityLeadTooltipVisible;
  }

  updateOpportunityLeadSearch(searchResult: ADUser) {
    this.opportunityLead = searchResult;
    this.facility.businessPotential.opportunityLead = this.opportunityLead.displayName;
    this.opportunityLeadVisible = !this.opportunityLeadVisible;
  }

  updateLastContactedBySearch(searchResult: ADUser) {
    this.lastContactedBy = searchResult;
    this.facility.businessPotential.lastContactedBy = this.lastContactedBy.displayName
    this.lastContactedByVisible = !this.lastContactedByVisible;
  }

}